export default ["top-left", "top-right", "bottom-right", "bottom-left", "centered-top", "centered-bottom", "inline"];
